import client from "./client";
import EndUrls from "./endUrls";
import { getService, patchService, postService } from "./services";

export const handleLoginApiCall = async (data) => await client.post(EndUrls.login, data);

export const handleAdduserApiCall = async (data) =>
   await postService(EndUrls.addUser, data, true);

export const handleListuserApiCall = async (params) => {
   const cleanParams = params
      ? Object.fromEntries(
           Object.entries(params).filter(([, v]) => v !== undefined && v !== null && v !== ""),
        )
      : null;
   const query = cleanParams ? new URLSearchParams(cleanParams).toString() : "";
   return await getService(`${EndUrls.listUser}${query ? `?${query}` : ""}`, true);
};

export const handleGetParentRoleApiCall = async (data) =>
   await getService(EndUrls.parentRole, true);

// Add Location Master
export const handleAddLocationMaster = async (data) =>
   await postService(EndUrls.addLocationMaster, data, true);

export const handleLocationMasterList = async () =>
   await getService(EndUrls.locationMasterList, true);

export const handleLocationMasterSingleList = async (id, model_id, action_id) =>
   await getService(EndUrls.locationMasterSingleList(id, model_id, action_id), true);

export const handleLocationMasterUpdate = async (data) =>
   await patchService(EndUrls.locationMasterUpdate, data, true);

export const handleLocationMasterRemove = async (id) =>
   await getService(EndUrls.locationMasterDelete(id, true));

// Node Master
export const handleAddNodeMaster = async (data) =>
   await postService(EndUrls.addNodeMaster, data, true);

export const handleNodeMasterList = async () =>
   await getService(EndUrls.NodeMasterList, true);

export const handleNodeMasterSingleList = async (id, model_id, action_id) =>
   await getService(EndUrls.nodeMasterSingleList(id, model_id, action_id), true);

export const handleNodeMasterUpdate = async (data) =>
   await patchService(EndUrls.NodeMasterUpdate, data, true);

export const handleNodeMasterRemove = async (id) =>
   await getService(EndUrls.NodeMasterDelete(id, true));

// Add Company Master
export const handleCompanyMaster = async (data) =>
   await postService(EndUrls.addCompanyMaster, data, true);

export const handleCompanyMasterList = async () =>
   await getService(EndUrls.companyMasterList, true);

export const handleCompanyMasterSingleList = async (id) =>
   await getService(EndUrls.companyMasterSingleList(id), true);

export const handleCompanyMasterUpdate = async (data) =>
   await patchService(EndUrls.companyMasterUpdate, data, true);

/// Kiloleter Master services api
export const handleKiloleteMaster = async (data) =>
   await postService(EndUrls.addKiloleterMaster, data, true);

export const handleKiloleterMasterList = async () =>
   await getService(EndUrls.kiloleterMasterList, true);

export const handleKiloleterMasterSingleList = async (id) =>
   await getService(EndUrls.kiloleterMasterSingleList(id), true);

export const handleKiloleterMasterUpdate = async (data) =>
   await patchService(EndUrls.kiloleterMasterUpdate, data, true);

export const handleKiloleterMasterRemove = async (id) =>
   await getService(EndUrls.kiloleterMasterDelete(id), true);

////  Reports all apis
export const reportDropDownRecordList = async () =>
   await getService(EndUrls.filterDropDown, true);

export const handleLoadingReportMasterList = async (data) =>
   await postService(EndUrls.loadingReportMasterList, data, true);

export const handlevehicleShortageSummaryMasterList = async (data) =>
   await postService(EndUrls.vehicleShortageSummaryMasterList, data, true);

export const handleTripExpensesSummaryMasterList = async (data) =>
   await postService(EndUrls.tripExpensesSummaryMasterList, data, true);

export const handlePerformanceReportMasterList = async (data) =>
   await postService(EndUrls.performanceReportMasterList, data, true);

export const handlemonthlyLoadingGraphList = async (data) =>
   await postService(EndUrls.monthlyLoadingGraphList, data, true);

// Tonnage Master list

export const handleTonnageMaster = async (data) =>
   await postService(EndUrls.addTonnageMaster, data, true);

export const handleTonnageList = async () => await getService(EndUrls.tonnageList, true);

export const handleTonnageMasterSingleList = async (id) =>
   await getService(EndUrls.tonnageMasterSingleList(id), true);

export const handleTonnageMasterDelete = async (id) =>
   await getService(EndUrls.tonnageMasterDelete(id), true);

export const handleTonnageMasterUpdate = async (data) =>
   await patchService(EndUrls.tonnageMasterUpdate, data, true);

// Vehicle Category Master List
export const storeleVehicleCategoryMaster = async (data) =>
   await postService(EndUrls.addVehicleCategory, data, true);

export const getCategoryList = async () => await getService(EndUrls.categoryList, true);

export const getcategoryRecord = async (id) =>
   await getService(EndUrls.categorySingleRecord(id), true);

export const updateVehicleCategoryMaster = async (data) =>
   await patchService(EndUrls.updateVehicleCategory, data, true);

// export const handleGetParentRoleApiCall= async (data)=> await client.get(EndUrls.parentRole, {headers:{Authorization : `Bearer ${JSON.parse(localStorage.getItem('token'))}`}})

export const handleEdituserApiCall = async (data) =>
   await patchService(EndUrls.editUser, data, true);

// fleet master
export const getDropdownDataApiCall = async () =>
   await getService(EndUrls.getDropdownData, true);

export const addFleetApiCall = async (data) =>
   await postService(EndUrls.addFleet, data, true);

export const addVehicleAndEmiDetailsApiCall = async (data) =>
   await postService(EndUrls.addVehicleAndEmiDetails, data, true);

export const listFleetApiCall = async (params) => {
   const cleanParams = params
      ? Object.fromEntries(
           Object.entries(params).filter(([, v]) => v !== undefined && v !== null && v !== ""),
        )
      : null;
   const query = cleanParams ? new URLSearchParams(cleanParams).toString() : "";
   return await getService(`${EndUrls.listFleet}${query ? `?${query}` : ""}`, true);
};

export const listFleetExpirationApiCall = async (expiryStartDate, expiryEndDate) => {
   let url = EndUrls.listFleet;
   const params = [];
   if (expiryStartDate) params.push(`expiry_start_date=${expiryStartDate}`);
   if (expiryEndDate) params.push(`expiry_end_date=${expiryEndDate}`);
   if (params.length > 0) url += `?${params.join("&")}`;
   return await getService(url, true);
};

export const listFleetExpiredDocumentApiCall = async () =>
   await getService(EndUrls.listExpiredFleet, true);

export const singleFleetApiCall = async (id) =>
   await getService(EndUrls.fetchFleetRecordById(id), true);

export const updateFleetApiCall = async (data) =>
   await postService(EndUrls.updateFleet, data, true);

export const downloadPDFApiCall = async (data) =>
   await postService(EndUrls.downloadFleet, data, true);

// driver master
export const fetchAllContractorsApiCall = async () =>
   await getService(EndUrls.fetchAllContractors, true);

export const fetchAllFleetApiCall = async () =>
   await getService(EndUrls.fetchAllFleets, true);

export const fetchAllFleetEditApiCall = async () =>
   await getService(EndUrls.fetchAllFleetsEdit, true);

export const fetchAllUniqueFleetApiCall = async () =>
   await getService(EndUrls.fetchAllUniqueFleet, true);

export const trackVehicleApiCall = async (regNo) =>
   await getService(EndUrls.trackVehicle(regNo), true);

export const addDriverMasterApiCall = async (data) =>
   await postService(EndUrls.addDriverMaster, data, true);

export const listDriverMasterApiCall = async (params) => {
   const cleanParams = params
      ? Object.fromEntries(
           Object.entries(params).filter(([, v]) => v !== undefined && v !== null && v !== ""),
        )
      : null;
   const query = cleanParams ? new URLSearchParams(cleanParams).toString() : "";
   return await getService(`${EndUrls.listDriverMaster}${query ? `?${query}` : ""}`, true);
};

export const updateDriverMasterApiCall = async (data) =>
   await postService(EndUrls.updateDriverMaster, data, true);

export const getDriverDropdownDataApiCall = async () =>
   await getService(EndUrls.getDriverDropdownData, true);

export const getCustomerDropdownDataApiCall = async () =>
   await getService(EndUrls.getCustomerDropdownData, true);

export const getDriverRecordByVendorId = async (id) =>
   await getService(EndUrls.getDriverRecordByVendorId(id), true);

export const fetchFleetAssignmentDriverList = async () =>
   await getService(EndUrls.fetchFleetAssignmentDriverList, true);

export const fetchFleetAssignmentFleetList = async () =>
   await getService(EndUrls.fetchFleetAssignmentFleetList, true);

export const updateFleetAssignmentApiCall = async (data) =>
   await postService(EndUrls.updateFleetAssignment, data, true);

export const unassignFleetApiCall = async () =>
   await getService(EndUrls.unassignFleet, true);

// customer master
// export const fetchAllCustomersApiCall = async () =>
//   await client.get(EndUrls.fetchAllCustomers, config);

export const addCustomerMasterApiCall = async (data) =>
   await postService(EndUrls.addCustomerMaster, data, true);

export const listCustomerMasterApiCall = async (params) => {
   const cleanParams = params
      ? Object.fromEntries(
           Object.entries(params).filter(([, v]) => v !== undefined && v !== null && v !== ""),
        )
      : null;
   const query = cleanParams ? new URLSearchParams(cleanParams).toString() : "";
   const separator = EndUrls.listCustomerMaster.includes("?") ? "&" : "?";
   return await getService(`${EndUrls.listCustomerMaster}${query ? `${separator}${query}` : ""}`, true);
};

export const updateCustomerMasterApiCall = async (id,data) =>
   await postService(EndUrls.updateCustomerMaster(id), data, true);

// export const handleContractorMasterApiCall = async (data) =>
//   await client.post(EndUrls.contractorAdd, data, {
//     headers: {
//       Authorization: `Bearer ${JSON.parse(localStorage.getItem("token"))}`,
//     },
//   });

// Lane Master

export const addLaneMasterApiCall = async (data) =>
   await postService(EndUrls.addLaneMaster, data, true);

export const getLaneMasterApiCall = async (data) =>
   await getService(EndUrls.getAllLane, data, true);

/// Trip Master
export const addTripMasterApiCall = async (data) =>
   await postService(EndUrls.addTripMaster, data, true);

export const listTripAddEditApiCall = async () =>
   await getService(EndUrls.listTripAddEdit, true);

//Helper master
// Add Helper-master
export const addHelperMasterApiCall = async (data) =>
   await postService(EndUrls.addHelperMaster, data, true);

export const getAllVendorsApiCall = async () =>
   await getService(EndUrls.getAllVendors, true);

export const getLaneRecordById = async (id) =>
   await getService(EndUrls.getLaneDetail(id), true);

export const listLaneMasterApiCall = async () =>
   await getService(EndUrls.listLaneMaster, true);

// export const updateLaneMasterApiCall = async (data) =>
//   await client.post(EndUrls.updateLaneMaster, data, config);
// Get Helper-master
export const listHelperMasterApiCall = async (params) => {
   const cleanParams = params
      ? Object.fromEntries(
           Object.entries(params).filter(([, v]) => v !== undefined && v !== null && v !== ""),
        )
      : null;
   const query = cleanParams ? new URLSearchParams(cleanParams).toString() : "";
   const separator = EndUrls.listHelperMaster.includes("?") ? "&" : "?";
   return await getService(`${EndUrls.listHelperMaster}${query ? `${separator}${query}` : ""}`, true);
};

// Get single Helper-master
export const fetchSingleHelperMasterApiCall = async (id) =>
   await getService(`/helper/fetch/${id}?&model_id=5&action_id=3`, true);

// Update Helper Master
export const updateHelperMasterApiCall = async (data) =>
   await postService(EndUrls.updateHelperMaster, data, true);

// Get all lane
export const getAllLaneApiCall = async () => {
   return await getService(EndUrls.listLane, true);
};
export const updateLaneApiCall = async (data) => {
   return await postService(EndUrls.updateLane, data, true);
};
// Vendor Master
//add vendor
export const addVendorMasterApiCall = async (data) =>
   await postService(EndUrls.addVendorMaster, data, true);

// Vendor list
export const listVendorMasterApiCall = async () =>
   await getService(EndUrls.listVendorMaster, true);

// Contact person details
export const contactPersonDetailsApiCall = async (id) =>
   await getService(
      `/vendor/fetch/child/${id}?&table_name=contact_person_details&model_id=7&action_id=3`,
      true,
   );

// Get single vendorMaster
export const singleVendorMasterApiCall = async (id) =>
   await getService(`/vendor/fetch/${id}?&model_id=7&action_id=3`, true);

export const updateContactApi = async (data) =>
   await postService("/vendor/update/child", data, true);

// Lanne master details
export const laneMasterDetailsApiCall = async (id) =>
   await getService(
      `/vendor/fetch/child/${id}?&table_name=lane_masters&model_id=7&action_id=3`,
      true,
   );

// Update contact
export const updateVendorChildApi = async (data) =>
   await postService("/vendor/update/child", data, true);

// Add contact for vendor
export const addVendorChildApi = async (data) =>
   await postService("/vendor/add/child", data, true);

// update vendor
export const updateVendorApi = async (data) =>
   await postService("/vendor/update", data, true);

// contractor master
export const handleContractorMasterApiCall = async (data) =>
   await postService(EndUrls.contractorAdd, data, true);

export const handleContractorMasterListApiCall = async (params) => {
   const cleanParams = params
      ? Object.fromEntries(
           Object.entries(params).filter(([, v]) => v !== undefined && v !== null && v !== ""),
        )
      : null;
   const query = cleanParams ? new URLSearchParams(cleanParams).toString() : "";
   const separator = EndUrls.contractorList.includes("?") ? "&" : "?";
   return await getService(`${EndUrls.contractorList}${query ? `${separator}${query}` : ""}`, true);
};

export const handleContractorMasterEditApiCall = async (data) =>
   await postService(EndUrls.contractorUpdate, data, true);

export const handleContractorcontactsdetailsApiCall = async (id) =>
   await getService(EndUrls.singleConractorContactDetails(id), true);

export const handlesingleContractorcontactsdetailsAddApiCall = async (data) =>
   await postService(EndUrls.singleConractorContactAdd, data, true);

export const handlesingleContractorcontactsdetailsEditApiCall = async (data) =>
   await postService(EndUrls.singleConractorContactEdit, data, true);

//Trip
// Get all trip api
export const listTripApiCall = async (
   role = "corporateAdmin",
   id,
   limit,
   offset,
   trip_status,
   review_status,
) => {
   let url =
      role === "corporateAdmin"
         ? EndUrls.listTrip
         : role === "manager"
           ? EndUrls.managerTripList(id)
           : EndUrls.listTrip;

   // Append query parameters
   const params = new URLSearchParams();
   if (limit) params.append("limit", limit);
   if (offset) params.append("offset", offset);
   if (trip_status) params.append("trip_status", trip_status);
   if (review_status) params.append("review_status", review_status);

   url += `&${params.toString()}`;

   return await getService(url, true);
};

export const listTripByPaginationApiCall = async (
   role = "corporateAdmin",
   id,
   limit,
   page,
   trip_status,
   review_status,
   search,
) => {
   let url = EndUrls.listTripByPagination;

   // Calculate offset from page and limit
   const offset = page * limit;

   // Append query parameters
   const params = new URLSearchParams();
   if (limit) params.append("limit", limit);
   if (offset !== undefined) params.append("offset", offset);
   if (trip_status) params.append("trip_status", trip_status);
   if (review_status) params.append("review_status", review_status);
   if (search) params.append("search", search);

   url += `&${params.toString()}`;

   return await getService(url, true);
};

// Get single trip api
export const singleTripApiCall = async (id) =>
   await getService(EndUrls.singleTrip(id), true);

// Update trip manager api
export const updateTripManagerApiCall = async (data) =>
   await postService(EndUrls.updateTripManager, data, true);

// Update trip manager api
export const updateTripDetailsApiCall = async (data) =>
   await postService(EndUrls.updateTripDetails, data, true);

// Approve trip manager api
export const approveTripDetailsApiCall = async (data) =>
   await postService(EndUrls.approveTripDetails, data, true);

export const rejectTripDetailsApiCall = async (data) =>
   await postService(EndUrls.rejectTripDetails, data, true);

// Update trip review status
export const updateTripReviewStatusApiCall = async (data) =>
   await postService(EndUrls.updateTripReviewStatus, data, true);

// Update adhoc trip review status
export const updateAdhocTripReviewStatusApiCall = async (data) =>
   await postService(EndUrls.updateAdhocTripReviewStatus, data, true);

export const addAdhocLaneApiCall = async (data) =>
   await postService(EndUrls.addhocLaneAdd, data, true);

// Edit adhoc lane
export const editAdhocLaneApiCall = async (data) =>
   await postService(EndUrls.adhocLaneEdit, data, true);

export const getAdhocLaneListApiCall = async () =>
   await getService(EndUrls.getAdhocLaneList(2, 3), true);

export const getAdhocLaneApiCall = async (laneId) =>
   await getService(EndUrls.getAdhocLane(laneId, 2, 3), true);

// Update lane review status
export const updateAdhocLaneReviewStautsApiCall = async (data) =>
   await postService(EndUrls.updateAdhocLaneReviewStauts, data, true);

// Get all Adhoc trip list
export const getAdhocTripApiCall = async (role) =>
   await getService(EndUrls.adhocTripList, true);

// Get all Adhoc trip list by pagination
export const getAdhocTripByPaginationApiCall = async (
   limit,
   page,
   trip_status,
   review_status,
   search,
) => {
   let url = EndUrls.adhocTripListByPagination;

   // Calculate offset from page and limit
   const offset = page * limit;

   // Append query parameters
   const params = new URLSearchParams();
   if (limit) params.append("limit", limit);
   if (offset !== undefined) params.append("offset", offset);
   if (trip_status) params.append("trip_status", trip_status);
   if (review_status) params.append("review_status", review_status);
   if (search) params.append("search", search);

   url += `&${params.toString()}`;

   return await getService(url, true);
};
// Get single adhoc trip
export const getSingleAdhocTripApiCall = async (id) =>
   await getService(EndUrls.getSingleAdhocTrip(id), true);

// Update adhoc trip manager
export const updateAdhocTripManagerApiCall = async (data) =>
   await postService(EndUrls.adhocTripUpdateManager, data, true);

export const createActualApiCall = async (data) =>
   await postService(EndUrls.createActual, data, true);

export const createActualAdhocApiCall = async (data) =>
   await postService(EndUrls.createActualAdhoc, data, true);

// Contractor master single
export const getSingleContractorMasterApiCall = async (id) =>
   await getService(EndUrls.singleContractorMaster(id), true);

// reports
export const fleetReportApiCall = async (data) =>
   await postService(EndUrls.fleetReport, data, true);

// Fleet Maintainance Report
export const fleetMaintainanceReportApiCall = async (data) =>
   await postService(EndUrls.fleetMaintainanceReport, data, true);

// Customer Master Report
export const customerMasterReportApiCall = async (data) =>
   await postService(EndUrls.customerMasterReport, data, true);

// Fleet EMI Report Vendor Specific
export const fleetEMIVendorReportApiCall = async (data) =>
   await postService(EndUrls.fleetEMIVendorReport, data, true);

// Fleet EMI Report
export const fleetEMIReportApiCall = async (data) =>
   await postService(EndUrls.fleetEMIReport, data, true);

// Fleet Expiration Report
export const fleetExpirationReportApiCall = async (data) =>
   await postService(EndUrls.fleetExpirationReport, data, true);

// Vendor Master Report
export const vendorMasterReportApiCall = async (data) =>
   await postService(EndUrls.vendorMasterReport, data, true);

// Driver Master Report
export const driverMasterReportApiCall = async (data) =>
   await postService(EndUrls.driverMasterReport, data, true);

export const driverSalaryReportApiCall = async (data) =>
   await postService(EndUrls.driverSalaryReport, data, true);

// Helper Master Report
export const helperMasterReportApiCall = async (data) =>
   await postService(EndUrls.helperMasterReport, data, true);

// Contractor Master Report
export const contractorMasterReportApiCall = async (data) =>
   await postService(EndUrls.contractorMasterReport, data, true);

// Lane Master Report
export const laneMasterReportApiCall = async (data) =>
   await postService(EndUrls.laneMasterReport, data, true);

////// dashbaord
export const currentOpenTripList = async () =>
   await getService(EndUrls.currentOpenTrip, true);
export const unassignedTripList = async () =>
   await getService(EndUrls.unassignedTripVehicles, true);

// Trip Master Report
export const tripMasterReportApiCall = async (data, params) => {
   const queryString = new URLSearchParams(params).toString(); // Convert params object to a query string
   const url = `${EndUrls.tripMasterReport}?${queryString}`; // Append params to URL

   return await postService(url, data, true);
};

// Trip Master Dashboard Report
export const tripDashboardReportApiCall = async (startDate, endDate) => {
   const params = new URLSearchParams();
   if (startDate) params.append("startDate", startDate);
   if (endDate) params.append("endDate", endDate);
   const queryString = params.toString();
   const url = queryString ? `${EndUrls.tripDashboardReport}?${queryString}` : EndUrls.tripDashboardReport;
   return await getService(url, true);
};

// Config
export const addConfigApiCall = async (data) =>
   await postService(EndUrls.addConfig, data, true);

